module.exports = __webpack_public_path__ + "static/media/sage.0df21dde.png";